import type { IconSvgObject } from './types';

const TabletConnectedBluetoothIcon: IconSvgObject = [
  ["path", { d: "M21.5 4.5C21.278 3.63739 20.4319 3 19.5 3H4.5C3.39543 3 2.5 3.89543 2.5 5V19C2.5 20.1046 3.39543 21 4.5 21H19.5C20.4319 21 21.278 20.3626 21.5 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 3V21", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 15L21.5 9L18.0008 7V17L21.5 15L14.5 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TabletConnectedBluetoothIcon;
